import React, { useState } from 'react';
import Checkbox from '../../../Components/Base/Checkbox/Checkbox';
import { useSetUserNotificationSettingsMutation } from '../../../graphql/graphql';

interface Props {
	name: string;
	id: string;
	isChecked: boolean;
	onChange: () => void;
}

const NotificationsSetup: React.FC<Props> = ({
	name,
	id,
	isChecked,
	onChange,
}) => {
	const [saveSettings] = useSetUserNotificationSettingsMutation();

	const handleOnChange = async (value: boolean, id: string) => {
		await saveSettings({ input: { typeTermItemId: id, sending: value } });
		onChange();
	};

	return (
		<Checkbox
			tx={name}
			onChange={(value: boolean) => handleOnChange(value, id)}
			value={isChecked}
		/>
	);
};

export default NotificationsSetup;
